import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { of } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ApiService {
  endpoint = this.globalService.endpoint;
  private httpBend: HttpClient;

  constructor(
    private http: HttpClient, 
    private auth: AuthService, 
    private globalService: GlobalService,
    private handler: HttpBackend
  ) {
    this.httpBend = new HttpClient(handler);
  }

  downloadPDF(params: any) {
    var mediaType = 'application/pdf';
    const url = this.endpoint + 'docs/downloadfile';
    return this.http.post<any>(url, params, {headers: this.globalService.getHeaders(), responseType:'blob' as 'json' }).pipe(map(response => {
      return response;
    }, (error: any) => {
      console.error(error);
    }));   
  }

  downloadDocument(params: any) {
    var mediaType = 'application/pdf';
    const url = this.endpoint + 'docs/downloadfile';
    return this.http.get<any>(url, params ).pipe(map(response => {
      return response;
    }, (error: any) => {
      console.error(error);
    }));   
  }

  get(api:string) {
    const url = this.endpoint + api;
    return this.http.get<any>(url, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, (error: any) => {
      console.error(error);
    }));
  }
  
  uploadpost(api:string,params: any) {
    const url = this.endpoint + api;
    return this.http.post<any>(url, params, {headers: this.globalService.getHeadersUpload()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, (error: any) => {
      console.error(error);
    }));
  }

  
  post(api:string,params: any) {
    const url = this.endpoint + api;
    let par:any=params;
    if(!par){
      par={};
    }
    if(this.globalService.getUser()){
      par.user_id=this.globalService.getUser().id;
    }
   
    return this.http.post<any>(url, par, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, (error: any) => {
      console.error(error);
    }));
  }
  
  postobs(api:string,params: any) {
    const url = this.endpoint + api;
    return this.http.post<any>(url, params, {headers: this.globalService.getHeaders()});
  }
  

}
